module.exports = __webpack_public_path__ + "static/img/logo.52fc941b.png";